import { createAPI, decryptUrl } from '@common'
const requestCommonAPI = function (url, action, config, vconfig) {
  // 解码url
  url = decryptUrl(url)
  if (vconfig && vconfig.url) {
    url = vconfig.url + url
    return createAPI(url, action, config, {
      hubForward: true,
      hub: '/e5/hub',
      ...vconfig
    })
  }
  return createAPI(url, action, config, vconfig)
}
export default {
  getE5Conditions: (config, vconfig) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0f60dpoejujpot',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub', ...vconfig, isMicro: true }
      )
    } else {
      return createAPI('customEncryptApiName-1/0f60dpoejujpot',
        'get',
        { params: config.params },
        { ...vconfig, isMicro: true }
      )
    }
  },
  getE5Lists: (config, vconfig) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0f60mjtut',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub', ...vconfig, isMicro: true }
      )
    } else {
      return createAPI('customEncryptApiName-1/0f60mjtut',
        'get',
        { params: config.params },
        { ...vconfig, isMicro: true }
      )
    }
  },
  /**
   * TODO 接口前缀需要根据微应用进行变更对应后台的不同微服务，需要进一步统一处理
   * 例如
   * 发布中心为/mediax-articleapp/e5/listdata
   * 系统管理为/mediax-system/e5/listdata
   */
  postE5ListData: (config, vconfig) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0f60mjtuebub',
        'post',
        { data: config.data },
        { hubForward: true, hub: 'e5/hub', ...vconfig, isMicro: true }
      )
    } else {
      return createAPI('customEncryptApiName-1/0f60mjtuebub',
        'post',
        { data: config.data },
        { ...vconfig, isMicro: true }
      )
    }
  },
  getE5Actions: (config, vconfig) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0f60bdujpot',
        'get',
        { params: config.params },
        {
          neverLoading: true,
          hubForward: true,
          hub: 'e5/hub',
          ...vconfig,
          isMicro: true
        }
      )
    } else {
      return createAPI('customEncryptApiName-1/0f60bdujpot',
        'get',
        { params: config.params },
        { neverLoading: true, ...vconfig, isMicro: true }
      )
    }
  },
  getE5Forms: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60gpsnt', 'get', config, { ...vconfig, isMicro: true }),
  /**
   * FIXME 不通，不通，空指针异常
   * @param config
   * @param vconfig
   */
  postE5FormsData: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60gpsnt0ebub', 'post', config, { ...vconfig, isMicro: true }),
  getE5Preaction: (config, vconfig) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0f60bdujpot0qsfbdujpo',
        'get',
        { params: config.params },
        {
          neverLoading: true,
          hubForward: true,
          hub: 'e5/hub',
          ...vconfig,
          isMicro: true
        }
      )
    } else {
      return createAPI('customEncryptApiName-1/0f60bdujpot0qsfbdujpo',
        'get',
        { params: config.params },
        { neverLoading: true, ...vconfig, isMicro: true }
      )
    }
  }, // e5/preaction?params={docLib:1,folder:1,action:1,ids: ["1,123","1,124",…]}
  getE5Postaction: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60bdujpot0qptubdujpo', 'get', config, {
      neverLoading: true,
      isMicro: true,
      ...vconfig
    }), // e5/preaction?params={docLib:1,folder:1,action:1,ids: ["1,123","1,124",…]}
  getE5Logs: (config, vconfig) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0f60mpht',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub', neverLoading: true, ...vconfig }
      )
    } else {
      return createAPI('customEncryptApiName-1/0f60mpht',
        'get',
        { params: config.params },
        { neverLoading: true, vconfig }
      )
    }
  },
  getForwardLogs: (config, vconfig) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20sppuBsujdmft0gpsxbse0mpht',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub', ...vconfig }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20sppuBsujdmft0gpsxbse0mpht',
        'get',
        { params: config.params },
        vconfig
      )
    }
  },
  getE5ActionsLogs: (config, vconfig) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0f60bdujpot0mpht',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub', ...vconfig }
      )
    } else {
      return createAPI('customEncryptApiName-1/0f60bdujpot0mpht',
        'get',
        { params: config.params },
        vconfig
      )
    }
  },
  getE5Folders: (config, vconfig) =>
    createAPI('customEncryptApiName-1/f60gpmefst', 'get', config, vconfig),
  getE5FoldersbBydocType: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60gpmefst0cz0epdUzqf', 'get', config, vconfig),
  getE5ListsDefinition: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60mjtut0efgjojujpo', 'get', config, vconfig),
  postE5ListsDefinition: (config) =>
    createAPI('customEncryptApiName-1/0f60mjtut0efgjojujpo', 'post', config),
  getE5Images: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0f60jnbhft',
      'get',
      { params: config.params },
      config.hubConfig
        ? {
            hubForward: true,
            hub: 'e5/hub',
            neverLoading: true,
            isHideErrorMessage: true,
            ...vconfig
          }
        : { neverLoading: true, isHideErrorMessage: true, ...vconfig }
    ),
  getE5FilesLink: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0gjmft0mjol',
      'get',
      { params: config.params },
      config.hubConfig
        ? {
            hubForward: true,
            hub: 'e5/hub',
            neverLoading: true,
            isHideErrorMessage: true,
            ...vconfig
          }
        : { neverLoading: true, isHideErrorMessage: true, ...vconfig }
    ),
  getE5ImageFile: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0f60jnbhfgjmf',
      'get',
      { ...config, responseType: 'arraybuffer' },
      {
        neverLoading: true,
        isHideErrorMessage: true,
        timeout: 120000,
        ...vconfig
      }
    ).then((resp) => {
      const imageType = resp.headers['content-type']
      const blob = new Blob([resp.data], { type: imageType })
      const url = (window.URL || window.webkitURL).createObjectURL(blob)
      return {
        ...resp,
        data: {
          buffer: resp.data,
          url
        }
      }
    }),
  getE5ImageUrl: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0qjd0hfuJnbhfVsm',
      'get',
      { ...config },
      {
        neverLoading: true,
        isHideErrorMessage: true,
        timeout: 120000,
        ...vconfig
      }
    ).then((resp) => {
      const url = resp.data.data
      return {
        ...resp,
        data: {
          url: url
        }
      }
    }),
  getE5Files: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0f60gjmft', 'get', config, {
      neverLoading: true,
      ...vconfig
    }),
  // 删除
  postE5Delete: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60efmfuf', 'post', config, vconfig),
  // 解锁
  postE5Unlocker: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60vompdlfs', 'post', config, vconfig),
  // 用户表单详情
  getUserDetails: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60efubjmt', 'get', config, vconfig),
  // 详情页操作
  getE5DetailActions: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60bdujpot0efubjmbdujpot', 'get', config, vconfig),
  // 角色管理-读角色权限：操作权限
  getE5AdminPermissionsActions: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60benjo0qfsnjttjpot0bdujpot', 'get', config, vconfig),
  // 角色管理-修改角色权限：操作权限
  postE5AdminPermissionsActions: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60benjo0qfsnjttjpot0bdujpot', 'post', config, vconfig),
  // 角色管理-读角色权限：文件夹操作权限
  getE5AdminPermissionsActionsFolder: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0f60benjo0qfsnjttjpot0bdujpot0gpmefs',
      'get',
      config,
      vconfig
    ),
  // 角色管理-修改角色权限：文件夹操作权限
  postE5AdminPermissionsActionsFolder: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0f60benjo0qfsnjttjpot0bdujpot0gpmefs',
      'post',
      config,
      vconfig
    ),
  // 角色管理-修改角色权限：文件夹操作权限-读文档树
  getE5AdminDomDoclibs: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0f60benjo0epn0epdmjct', 'get', config, vconfig),
  // 角色管理-修改角色权限：文件夹操作权限-读文档树
  getE5AdminDomDocType: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0f60gpmefst0cz0epdUzqf', 'get', config, vconfig),
  // 角色管理-修改角色权限：文件夹操作权限-读子文件夹树
  getE5AdminDomFolders: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0f60benjo0epn0gpmefst', 'get', config, vconfig),
  // 获取文件夹属性
  getE5AdminDomFolder: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0f60benjo0epn0gpmefs', 'get', config, vconfig),
  // 创建子文件夹、修改
  postE5AdminDomFolders: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0f60benjo0epn0gpmefst', 'post', config, vconfig),
  // 删除文件夹
  deleteE5AdminDomFolders: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0f60benjo0epn0gpmefst', 'delete', config, vconfig),
  // 机构树
  getE5AdminOrgsList: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60benjo0psht0mjtu', 'get', config, {
      ...vconfig,
      isMicro: true
    }),
  // 新建/编辑 机构
  postE5AdminOrgs: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60benjo0psht', 'post', config, { ...vconfig, isMicro: true }),
  // 删除 机构
  deleteE5AdminOrgs: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60benjo0psht', 'delete', config, {
      ...vconfig,
      isMicro: true
    }),
  // 新建/修改角色
  postE5AdminRoles: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60benjo0spmft', 'post', config, { ...vconfig, isMicro: true }),
  // 删除角色
  deleteE5AdminRoles: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60benjo0spmft', 'delete', config, {
      ...vconfig,
      isMicro: true
    }),
  // 获取角色列表
  getE5AdminRoles: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60benjo0spmft', 'get', config, { ...vconfig, isMicro: true }),
  // 获取云端稿库机构
  getE5UsersOrgs: (config, vconfig) =>
    createAPI('customEncryptApiName-1/w20vtfst0psht', 'get', config, vconfig),
  // 读流程
  getE5AdminFlows: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60benjo0gmpxt', 'get', config, {
      ...vconfig,
      isMicro: true,
      microPrefix: '/mediax-articleapp'
    }),
  // 登陆验证
  postE5LoginValidation: (config) =>
    createAPI('customEncryptApiName-1/0f60mphjo0wbmjebujpo', 'post', config),
  // 刷新缓存
  getE5AdminCachesAll: (config) =>
    createAPI('customEncryptApiName-1/0f60benjo0dbdift0bmm', 'get', config),
  // 读用户默认文件夹
  getE5AdminUsersFolders: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0f60benjo0vtfst0gpmefst', 'get', config, vconfig),
  // 保存用户默认文件夹
  postE5AdminUsersFolders: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0f60benjo0vtfst0gpmefst', 'post', config, vconfig),
  // 参数配置
  getE5AdminParams: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60benjo0qbsbnt', 'get', config, { ...vconfig, isMicro: true }),

  getParamsList: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0qbsbnt0mjtu', 'get', config, { ...vconfig, isMicro: true }),

  // 云端稿库-参数配置
  getRRAdminParams: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0benjo0qbsbnt', 'get', config),
  // 添加参数配置
  postE5AdminParams: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60benjo0qbsbnt', 'post', config, {
      ...vconfig,
      isMicro: true
    }),
  putE5AdminParams: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60benjo0qbsbnt', 'put', config, { ...vconfig, isMicro: true }),
  // 按指定的文档类型读子文件夹树
  deleteE5AdminParam: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60benjo0qbsbnt', 'delete', config, {
      ...vconfig,
      isMicro: true
    }),
  getE5FoldersByDocType: (config, vconfig) => {
    let url = '/e5/folders/by/docType'
    let _vconfig = {
      neverLoading: true,
      ...vconfig
    }
    if (vconfig.hubConfig) {
      url = 'NEWSPLAN:/e5/folders/by/docType'
      _vconfig.hubForward = true
      _vconfig.hub = 'e5/hub'
    }
    return createAPI(url, 'get', config, _vconfig)
  },
  // 根据folder获取子文件夹树
  getE5FoldersChildren: (config, vconfig) => {
    let url = '/e5/folders/children'
    let _vconfig = {
      neverLoading: true,
      ...vconfig
    }
    if (vconfig.hubConfig) {
      url = 'NEWSPLAN:/e5/folders/children'
      _vconfig.hubForward = true
      _vconfig.hub = 'e5/hub'
    }
    return createAPI(url, 'get', config, _vconfig)
  },
  // 广电文稿-按指定的文档类型读子文件夹树
  getE5FoldersByDocTypeUser: (config, vconfig) => {
    let url = '/e5/folders/by/docType/user'
    let _vconfig = {
      neverLoading: true,
      ...vconfig
    }
    if (vconfig.hubConfig) {
      url = 'NEWSPLAN:/e5/folders/by/docType/user'
      _vconfig.hubForward = true
      _vconfig.hub = 'e5/hub'
    }
    return createAPI(url, 'get', config, _vconfig)
  },
  // 广电文稿-根据folder获取子文件夹树
  getE5FoldersChildrenUser: (config, vconfig) => {
    let url = '/e5/folders/children/by/user'
    let _vconfig = {
      neverLoading: true,
      ...vconfig
    }
    if (vconfig.hubConfig) {
      url = 'NEWSPLAN:/e5/folders/children/by/user'
      _vconfig.hubForward = true
      _vconfig.hub = 'e5/hub'
    }
    return createAPI(url, 'get', config, _vconfig)
  },
  // 根据folder获取子文件夹树
  getE5AdminDomDoclibsByCodes: (config, vconfig) =>
    createAPI('customEncryptApiName-1/f60benjo0epn0epdmjct0cz0dpeft', 'get', config, vconfig),
  // 判断是否有操作权限
  getE5ActionsEnabled: (config, vconfig) =>
    createAPI('customEncryptApiName-1/f60bdujpot0fobcmfe', 'get', config, vconfig),
  // 读流程的接口
  getE5Flows: (config, vconfig) =>
    createAPI('customEncryptApiName-1/f60gmpxt', 'get', config, vconfig),
  // 读三方系统已有的列表
  getE5AdminClientsList: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60benjo0dmjfout0mjtu', 'get', config, vconfig),
  // 读权限（一个角色对某个三方系统的权限）
  getE5AdminPermissionsClient: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60benjo0qfsnjttjpot0dmjfou', 'get', config, vconfig),
  // 设置权限（一个角色对某个三方系统的权限）
  postE5AdminPermissionsClient: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60benjo0qfsnjttjpot0dmjfou', 'post', config, vconfig),
  // 读角色权限：文件夹权限
  getE5AdminPermissionsFlders: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60benjo0qfsnjttjpot0gpmefst', 'get', config, vconfig),
  // 保存角色权限：文件夹权限
  postE5AdminPermissionsFolders: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60benjo0qfsnjttjpot0gpmefst', 'post', config, vconfig),
  // 退出
  postE5Logout: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60mphpvu', 'post', config, vconfig),
  // 在不方便记录时从前端调用来写系统日志
  postE5AdminSyslog: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0f60benjo0tztmph', 'post', config, vconfig),
  // 新建修改来源
  postE5Sources: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0w20tpvsdft', 'post', config, vconfig)
}
